'use client';
import VideoMetaData from '../../../components/video-metadata';
import { cn } from '@bells/core/lib/utils';
import { forwardRef } from 'react';
import { type RatioVideoProps } from './video.type';

const RatioVideo = forwardRef<
  HTMLDivElement,
  RatioVideoProps & { classNames?: string[]; withPlaceholder?: boolean }
>(
  (
    {
      src,
      muted,
      rounded,
      loop,
      showControls,
      ratio,
      autoPlay,
      classNames,
      title,
      description,
      poster,
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          'w-full',
          classNames,
          rounded === true || rounded === 'true'
            ? 'overflow-hidden rounded-xl'
            : 'rounded-none'
        )}
      >
        <video
          loop={loop}
          muted={muted}
          autoPlay={autoPlay}
          controls={showControls}
          poster={poster?.url}
          style={{ aspectRatio: ratio }}
        >
          <source src={src?.url} />
        </video>

        {poster && src && (
          <VideoMetaData
            title={title}
            description={description}
            thumbnailUrl={poster?.url}
            contentUrl={src?.url}
          ></VideoMetaData>
        )}
      </div>
    );
  }
);
RatioVideo.displayName = 'RatioVideo';
export { RatioVideo };
